<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Asistencia</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <div class="col-md-4 col-lg-3">
            <b-form-group id="input-group-1" label="Grupo" label-for="input-2" description="Seleccione un grupo">
              <b-form-select v-model="filteredGroup" :options="filterGroups"></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4 col-lg-3">
            <b-form-group id="input-group-2" label="Fecha Reporte" label-for="input-3">
              <b-form-datepicker id="example-datepicker" v-model="startDate" placeholder="Fecha" value-as-date></b-form-datepicker>
            </b-form-group>
          </div>
          <div class="col-md-4 col-lg-3 mt-md-2 mb-4">
            <b-button class="mt-md-4" variant="primary" @click="search">Consultar</b-button>
          </div>
        </b-row>
        <b-table v-if="(classes.rows).length !== 0" striped hover :fields="columns" :items="classes.rows" head-variant="light" responsive>
          <template #cell(id)="attendance">
            {{ attendance.item.idUser}}
          </template>
          <template #cell(idUser)="attendance">
            {{attendance.item.student.name}} {{attendance.item.student.lastName}}  {{attendance.idUser}}
          </template>
          <template #cell(arrivalTime)="attendance">
            {{ showingDateFormat(attendance.item.arrivalTime) }}
          </template>
          <template #cell(departureTime)="attendance">
            {{ showingDateFormat(attendance.item.departureTime) }}
          </template>
        </b-table>
        <empty-table v-else/>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import axios from 'axios'
import store from 'store'
import emptyTable from '@/components/custom/cardEmptyList'
import { mapState } from 'vuex'
import { consts, getRoleNameById, showErrorMessage } from '@/services/utilities'
import moment from 'moment'

export default {
  name: 'Attendance',
  components: { emptyTable },
  data() {
    return {
      filteredGroup: null,
      filterGroups: [],
      startDate: '',
      cont: 0,
      classes: {
        rows: [],
        count: '',
      },
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'idUser', label: 'Usuario' },
        { key: 'arrivalTime', label: 'Hora de llegada' },
        { key: 'departureTime', label: 'Hora de salida' },
      ],
    }
  },
  beforeRouteEnter (to, from, next) {
    const userStorage = JSON.parse(store.get('userData'))
    function getGroupsByUser() {
      if (userStorage.role === getRoleNameById(consts.roles.ESTUDIANTE)) {
        return apiClient.get(`/group-subjects/students/${userStorage.id}/subjects`)
      } else {
        return apiClient.get('/groups')
      }
    }

    axios.all([getGroupsByUser()])
      .then(axios.spread(function (groupsByUser) {
        next((vm) => {
          console.log(groupsByUser)
          vm.setDataGroupsByUser(null, groupsByUser.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataGroupsByUser(err, [])
        })
      })
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    showingDateFormat: function (date) {
      if (date === null) {
        return 'Salida no registrada'
      }
      return moment(date).format('YYYY-MM-DD h:mm:ss a')
    },
    setDataGroupsByUser (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        if (this.user.role === getRoleNameById(consts.roles.ESTUDIANTE)) {
          this.classes = data
        } else {
          data.forEach(clase => {
            if (!this.filterGroups.find(f => f.value === clase.id)) {
              this.filterGroups.push({
                text: clase.name,
                value: clase.id,
              })
            }
          })
          this.filterGroups.unshift({ value: null, text: 'Seleccione un grupo' })
        }
      }
    },
    search() {
      apiClient.get('attendance', {
        params: {
          group: this.filteredGroup,
          date: this.startDate,
        },
      }).then(response => {
        this.classes = response.data
        console.log(this.classes)
        this.loading = false
      }).catch(e => {
        this.$notification.error({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(e),
        })
      })
    },
  },
  created() {
    this.startDate = new Date()
  },
}
</script>
